import {
  Pagination as MuiPagination,
  PaginationItem,
  type PaginationRenderItemParams,
} from "@mui/material";

import { PAGINATION_ITEM_SLOTS } from "ui/pagination/pagination.constants";
import { type PaginationProps } from "ui/pagination/pagination.types";

const renderApolloItem = (item: PaginationRenderItemParams) => (
  <PaginationItem slots={PAGINATION_ITEM_SLOTS} {...item} />
);

/**
 * MUI's `Pagination` on Figma's `Pagination/Item`: the look is the theme's, the glyphs are set here. A
 * call site's own `renderItem` replaces the glyphs along with everything else, as it would on MUI's.
 */
export const Pagination = ({
  showFirstButton = true,
  showLastButton = true,
  renderItem = renderApolloItem,
  ref,
  ...rest
}: PaginationProps) => (
  <MuiPagination
    ref={ref}
    showFirstButton={showFirstButton}
    showLastButton={showLastButton}
    renderItem={renderItem}
    {...rest}
  />
);
